import React from 'react';

import { formatMoney } from '../../../utils/formatMoney';

type TooltipEntry = {
  name?: string | number;
  value?: unknown;
  color?: string;
  dataKey?: unknown;
};

type DashboardChartTooltipProps = {
  active?: boolean;
  label?: string | number;
  payload?: readonly TooltipEntry[];
  valueFormat?: 'money' | 'count';
};

export function DashboardChartTooltip({ active, label, payload, valueFormat = 'money' }: DashboardChartTooltipProps) {
  if (!active || !payload || payload.length === 0) return null;

  const total = payload.reduce((sum, entry) => sum + Number(entry.value ?? 0), 0);
  const formatValue = (value: unknown) =>
    valueFormat === 'money' ? formatMoney(Number(value)) : Number(value).toLocaleString('de-DE');

  return (
    <div className="rounded-lg border border-app-border bg-app-surface px-3 py-2 shadow-lg">
      <p className="mb-1 text-xs font-semibold text-app-text-muted">{label}</p>
      {payload.map((entry) => (
        <div key={String(entry.dataKey ?? entry.name ?? '')} className="flex items-center justify-between gap-4 text-xs">
          <span className="flex items-center gap-1.5 text-app-text-subtle">
            <span className="inline-block h-2 w-2 rounded-full" style={{ background: entry.color }} />
            {entry.name}
          </span>
          <span className="font-medium text-app-text">{formatValue(entry.value ?? 0)}</span>
        </div>
      ))}
      {payload.length > 1 ? (
        <div className="mt-1 flex items-center justify-between gap-4 border-t border-app-border pt-1 text-xs">
          <span className="text-app-text-subtle">Gesamt</span>
          <span className="font-semibold text-app-text">{formatValue(total)}</span>
        </div>
      ) : null}
    </div>
  );
}
